import { call } from "../../tsrpc";
import { ReqGetTencentAdsRetentionOverview } from "../../shared/protocols/editor/PtlGetTencentAdsRetentionOverview";
import { ReqGetTencentAdsRetentionReports } from "../../shared/protocols/editor/PtlGetTencentAdsRetentionReports";
import { ReqRetryTencentAdsRetentionReports } from "../../shared/protocols/editor/PtlRetryTencentAdsRetentionReports";
import { ReqSaveTencentAdsRetentionConfig } from "../../shared/protocols/editor/PtlSaveTencentAdsRetentionConfig";

type AdminRequest<T extends { timestamp: number; token?: string }> = Omit<T, "timestamp" | "token">;

function withAuth<T extends object>(request: T): T & { timestamp: number; token: string } {
  return {
    ...request,
    timestamp: Date.now(),
    token: localStorage.getItem("token") || "",
  };
}

function fail(message: string, cause?: unknown): never {
  if (cause instanceof Error && cause.message && cause.message !== message) {
    throw new Error(`${message}：${cause.message}`);
  }
  throw new Error(message);
}

export async function getTencentAdsRetentionOverview(
  request: AdminRequest<ReqGetTencentAdsRetentionOverview>,
) {
  const result = await call("editor/GetTencentAdsRetentionOverview", withAuth(request))
    .catch((error) => fail("次日留存回传概览加载失败", error));
  if (!result.isSucc) fail(result.err?.message || "次日留存回传概览加载失败");
  return result.res.data;
}

export async function getTencentAdsRetentionReports(
  request: AdminRequest<ReqGetTencentAdsRetentionReports>,
) {
  const result = await call("editor/GetTencentAdsRetentionReports", withAuth(request))
    .catch((error) => fail("次日留存回传明细加载失败", error));
  if (!result.isSucc) fail(result.err?.message || "次日留存回传明细加载失败");
  return result.res.data;
}

export async function retryTencentAdsRetentionReports(
  request: AdminRequest<ReqRetryTencentAdsRetentionReports>,
) {
  const result = await call("editor/RetryTencentAdsRetentionReports", withAuth(request))
    .catch((error) => fail("次日留存任务重试提交失败", error));
  if (!result.isSucc) fail(result.err?.message || "次日留存任务重试提交失败");
  return result.res.data;
}

export async function saveTencentAdsRetentionConfig(
  request: AdminRequest<ReqSaveTencentAdsRetentionConfig>,
) {
  const result = await call("editor/SaveTencentAdsRetentionConfig", withAuth(request))
    .catch((error) => fail("次日留存运行配置保存失败", error));
  if (!result.isSucc) fail(result.err?.message || "次日留存运行配置保存失败");
  return result.res.data;
}
